import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {sortBySortOrder} from '../../_utils/sortable-utils';
import {MenuTopping} from '../../_models/menu-topping';
import {MenuItem} from '../../_models/menu-item';
import {OrderItemTopping} from '../../_models/order-item-topping';
import {OrderItem} from '../../_models/order-item';
import {ModifierDisplayPosition} from '../../_constants/modifier-display-position';

@Component({
    selector: 'bb-order-modifier',
    templateUrl: './order-modifier.component.html',
    styleUrls: ['./order-modifier.component.scss'],
})
export class OrderModifierComponent implements OnInit, OnChanges {
    @Input() modifiersDefinition: MenuTopping | MenuItem;
    @Input() modifiedItem: OrderItemTopping | OrderItem;

    @Input() sizeXs = 12;
    @Input() sizeSm = 12;
    @Input() sizeMd = 6;
    @Input() sizeLg = 4;
    @Input() sizeXl = 3;
    @Input() child = false;

    @Input() modifiers: any[];
    @Output() modifiersChange = new EventEmitter<any[]>();

    openOptionalModal = false;
    optionalModifiers: any[];
    initial = false;
    selections = [];
    optionalSelections = [];
    optional = [];

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.modifiers) {
            this.optionalModifiers = !!this.optional && this.optional.length > 0 ?
                this.optional.filter(o => this.modifiers.some(m => m.menuModifier.id === o.menuModifier.id)) : [];
        }
    }

    ngOnInit() {
        const modOptions = [
            ...this.modifiersDefinition.modifiers, ...this.modifiersDefinition.modifierSelections,
            ...this.modifiersDefinition.modifierGroups.reduce((acc, g) =>
                [...acc, ...g.menuModifierGroup.modifiers, ...g.menuModifierGroup.selections], [])
        ];

        modOptions.forEach(o => o.selected = this.modifiers.some(m => m.menuModifier.id === o.id));

        this.selections = sortBySortOrder(modOptions.filter(o => !!o.menuModifierSelection));

        this.optional = sortBySortOrder(modOptions.filter(o => !o.menuModifierSelection));

        this.optionalModifiers = !!this.optional && this.optional.length > 0 ?
            this.optional.filter(o => this.modifiers.some(m => m.menuModifier.id === o.menuModifier.id)) : [];
    }

    multiSelectionChange(selected: any) {
        if (!this.modifiers.some(m => selected.menuModifier.id === m.menuModifier.id)) {
            const modifiers = [...this.modifiers];

            modifiers.push({
                additionalPrice: selected.additionalPrice,
                menuModifier: selected.menuModifier,
                groupByModifier: false,
                modifierDisplayPosition: ModifierDisplayPosition.STANDARD,
                selectionName: null,
                selectionRequired: false,
                selectionSortOrder: null,
                sortOrder: selected.sortOrder
            });
            this.modifiersChange.emit(modifiers);
        } else {
            this.modifiersChange.emit(this.modifiers.filter(m => selected.menuModifier.id !== m.menuModifier.id));
        }
    }
}
